export default "__VITE_ASSET__d64a1478__"